import React, { useState, useRef, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import styles from './Recruits.module.css';
import { PlayerTable } from '../../components/PlayerTable/PlayerTable';

const Recruits = () => {
    
    const [players, setPlayers] = useState([]);
    const { refreshTrigger } = useOutletContext();
    const playerTableRef = useRef(null);

    // Listen for refresh trigger changes from Layout
    useEffect(() => {
        if (refreshTrigger > 0 && playerTableRef.current) {
            playerTableRef.current.refresh();
        }
    }, [refreshTrigger]);

    return (
        <div className={styles.recruitsContainer}> 
        
            <div className={styles.mainContent}>
                <PlayerTable ref={playerTableRef} onPlayersUpdate={setPlayers} /> 

            </div>
        </div>
            
    );
};

export default Recruits;
